import { createTheme, alpha } from "@mui/material/styles";

const darkGrey = {
  50: "#151c28",
  100: "#1c2533",
  200: "#263246",
  300: "#354158",
  400: "#4d5f78",
  500: "#6b7d94",
  600: "#8a9ab0",
  700: "#a8b4c4",
  800: "#c5ced9",
  900: "#e2e8f0",
  A100: "#2a3548",
  A200: "#354158",
  A400: "#6b7d94",
  A700: "#9aa8bc",
};

export const createAppTheme = (mode = "light") =>
  createTheme({
    palette: {
      mode,
      ...(mode === "dark" ? { grey: darkGrey } : {}),
      primary: {
        main: "#1976d2",
      },
      secondary: {
        main: "#dc004e",
      },
      background: {
        default: mode === "dark" ? "#0f1419" : "#f8f9fa",
        paper: mode === "dark" ? "#1a2230" : "#ffffff",
      },
      text: {
        primary: mode === "dark" ? "#e8edf5" : "#344767",
        secondary: mode === "dark" ? "#9aa8bc" : "#67748e",
      },
      divider:
        mode === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.08)",
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h6: {
        fontWeight: 400,
      },
    },
    shape: {
      borderRadius: 12,
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            scrollbarColor:
              mode === "dark" ? "#4a5568 #1a2230" : "#c1c1c1 #f8f9fa",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: ({ theme }) => ({
            backgroundColor:
              mode === "dark"
                ? alpha(theme.palette.background.paper, 0.92)
                : "rgba(255, 255, 255, 0.8)",
            color: theme.palette.text.primary,
          }),
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: ({ theme }) =>
            theme.palette.mode === "dark"
              ? {
                  backgroundColor: alpha(theme.palette.common.white, 0.04),
                  "&:hover": {
                    backgroundColor: alpha(theme.palette.common.white, 0.06),
                  },
                  "&.Mui-focused": {
                    backgroundColor: alpha(theme.palette.common.white, 0.06),
                  },
                }
              : {},
          notchedOutline: ({ theme }) => ({
            borderColor: theme.palette.divider,
          }),
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: ({ theme }) => ({
            backgroundColor: theme.palette.grey[100],
            color: theme.palette.text.primary,
            fontWeight: 600,
            borderBottom: `1px solid ${theme.palette.divider}`,
          }),
          root: ({ theme }) => ({
            borderColor: theme.palette.divider,
            color: theme.palette.text.primary,
          }),
        },
      },
      MuiTableRow: {
        styleOverrides: {
          head: ({ theme }) => ({
            backgroundColor: theme.palette.grey[100],
          }),
          root: ({ theme }) => ({
            "&:hover": {
              backgroundColor:
                theme.palette.mode === "dark"
                  ? alpha(theme.palette.common.white, 0.03)
                  : undefined,
            },
          }),
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: ({ theme }) => ({
            color: theme.palette.text.secondary,
            "&.Mui-focused": {
              color: theme.palette.primary.light,
            },
          }),
        },
      },
      MuiSelect: {
        styleOverrides: {
          icon: ({ theme }) => ({
            color: theme.palette.text.secondary,
          }),
        },
      },
    },
  });
